import { Timestamp } from "firebase/firestore/lite";
import { FirestoreRefs } from "ts-packages/commons/src/firebase/refs";

import type {
  FirestoreProductDocument,
  Product,
} from "@dashboard/types/product";

import { readEntitySource, writeEntitySource } from "./entitySource";

export const readProduct = (doc: FirestoreProductDocument): Product => {
  const { restaurantRef, createdAt, modifiedAt, source, ...productRest } = doc;

  const product: Product = {
    ...productRest,
    source: readEntitySource(source),
    createdAtMillis: createdAt.toMillis(),
    modifiedAtMillis: (modifiedAt || createdAt).toMillis(),
  };

  return product;
};

// Converts a product object to a firestore product document
export const writeProduct = (
  firestoreRefs: FirestoreRefs,
  product: Product,
  isNew: boolean
): FirestoreProductDocument => {
  const updateTs = Timestamp.now();
  const additionalFieldsNewProduct = isNew
    ? {
        createdAt: updateTs,
        restaurantRef: firestoreRefs.restaurant(product.restaurantUuid),
      }
    : {};

  // we don't write source to the product object in firestore.
  const { createdAtMillis, modifiedAtMillis, source, ...productRest } = product;
  const firestoreProduct = {
    ...productRest,
    ...additionalFieldsNewProduct,
    modifiedAt: updateTs,
    source: writeEntitySource(source),
  } as FirestoreProductDocument;

  return firestoreProduct;
};
